<template>
  <div>
    <!-- Filters -->
    <measures-list-filters
      :measure-filter.sync="measureStatusFilter"
      :measures-status-options="measuresStatusOptions"
    />

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Affichage</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>Mesures</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Rechercher..."
              />
              <b-button
                variant="primary"
                @click="$router.push({ name: 'apps-measure-add' })"
              >
                <span class="text-nowrap">Ajouter Mesure</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refMeasuresListTable"
        class="position-relative"
        :items="fetchMeasuresList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Pas de mesure trouvé"
        :sort-desc.sync="isSortDirDesc"
      >
      <!-- A virtual column -->
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
      
        <!-- Column: Status -->
        <template #cell(is_active)="data">
          <b-badge :variant="data.item.is_active ? 'primary' : 'danger'" class="text-capitalize">
            {{ data.item.is_active ? "Active" : "Inactive" }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <feather-icon
              :id="`measure-row-${data.item.uid}-edit-icon`"
              icon="EditIcon"
              class="cursor-pointer text-warning"
              size="16"
              @click="
                $router.push({
                  name: 'apps-measure-edit',
                  params: { id: data.item.uid }
                })
              "
            />
            <b-tooltip
              title="Modifier"
              class="cursor-pointer"
              :target="`measure-row-${data.item.uid}-edit-icon`"
              placement="left"
            />

            <feather-icon
              :id="`measure-row-${data.item.uid}-delete-icon`"
              icon="TrashIcon"
              size="16"
              class="mx-1 text-danger"
              @click="deleteMeasure(data.item.uid)"
            />
            <b-tooltip
              title="Supprimer Mesure"
              :target="`measure-row-${data.item.uid}-delete-icon`"
              placement="right"
            />
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Affichage de {{ dataMeta.from }} à {{ dataMeta.to }} sur
              {{ dataMeta.of }} mesures</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalMeasures"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable */
import {
  BTooltip,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import MeasuresListFilters from "./MeasuresListFilters.vue";
import useMeasuresList from "./useMeasuresList";

export default {
  name: "MeasuresList",
  components: {
    MeasuresListFilters,

    BTooltip,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,

    vSelect,
  },
  setup() {
    const {
      fetchMeasuresList,
      tableColumns,
      perPage,
      currentPage,
      totalMeasures,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refMeasuresListTable,
      refetchData,
      toggleMeasure,
      deleteMeasure,

      // Extra Filters
      measureStatusFilter,
      measuresStatusOptions,
    } = useMeasuresList();

    return {
      fetchMeasuresList,
      tableColumns,
      perPage,
      currentPage,
      totalMeasures,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refMeasuresListTable,
      refetchData,
      toggleMeasure,
      deleteMeasure,

      measureStatusFilter,
      measuresStatusOptions,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
